import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { NgxChartsModule, PieChartModule } from '@swimlane/ngx-charts';
import { MatSelectModule, MAT_CHECKBOX_CLICK_ACTION, MatRadioButton, MatRadioModule, MatDialogModule, MatInputModule, MatFormFieldModule, MatTableModule, MatIconModule, MatButtonModule, MatPaginatorModule } from '@angular/material';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { VumatelapplicationhistoryRoutingModule } from './vumatelapplicationhistory-routing.module';
import { VumatelapplicationhistoryComponent } from './vumatelapplicationhistory.component';



@NgModule({
  declarations: [VumatelapplicationhistoryComponent],
  imports: [
    CommonModule,
    NgbModule,
    MatchHeightModule,
    NgxChartsModule,
    PieChartModule,
    VumatelapplicationhistoryRoutingModule,
    MatSelectModule,
    SharedModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatButtonModule,

  ],
  providers: [MatRadioModule,
    {provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'check'}
  ]
})
export class  VumatelapplicationhistoryModule { }
